var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttentionIconRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18.183,
    viewBox: "0 0 20 18.183"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Attention_icon_red_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4c4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d80b0b"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.722 17.1l-7.98-14.074a1.99 1.99 0 00-3.49 0L1.272 17.1a2.054 2.054 0 001.745 3.081h15.96a2.054 2.054 0 001.745-3.081zm-8.916-5.217a.809.809 0 11-1.618 0V8.361a.809.809 0 111.618 0zM11 17.041a1.336 1.336 0 111.306-1.341A1.318 1.318 0 0111 17.041z",
    transform: "translate(-.997 -1.993)",
    fill: "url(#Attention_icon_red_svg__a)"
  })));
}
export default SvgAttentionIconRed;